import React, { useEffect } from "react";
import SectionTitle from "../common/SectionTitle";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";
import { useIntakeFormStore } from "../../stores/intakeFormStore";

interface ClientStatementSectionProps extends FormSectionProps {
  clientName?: string;
}

const ClientStatementSectionV2: React.FC<ClientStatementSectionProps> = (props) => {
  const { Field, formData, isEditMode = true } = useFormSection(props);
  const updateField = useIntakeFormStore((state) => state.updateField);
  
  const clientStatementData = formData?.clientStatement || {};
  const clientName = props.clientName || formData?.personalInfo?.fullName || "";

  useEffect(() => {
    if (clientName && !clientStatementData.clientNameStatement) {
      updateField("clientStatement.clientNameStatement", clientName);
    }
  }, [clientName, clientStatementData.clientNameStatement, updateField]);

  return (
    <section>
      <SectionTitle>Client Statement</SectionTitle>
      <div className="bg-brand-stone-50 p-6 rounded-lg border border-brand-stone-200 space-y-4 text-brand-stone-600">
        <p>
          I,{" "}
          <Field
            path="clientStatement.clientNameStatement"
            type="text"
            render={({ value, onChange }) => (
              <input
                type="text"
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                required
                className="px-2 py-1 border-b-2 w-64 border-brand-stone-300 focus:border-brand-green-500 bg-transparent"
                aria-label="Client Name in Statement"
                disabled={!isEditMode}
              />
            )}
          />
          , agree to allow Hailey Chilton to design a program for me to enhance my health as my Registered Holistic Nutritionist. I understand that the Hailey Chilton does not provide medical advice, nor will she diagnose medical conditions. I understand that the services provided are at all times restricted to consultation on the subject of health matters intended for general well-being and are not meant for the purposes of medical diagnosis, treatment, or prescribing of medicine for any disease, or any licensed or controlled act which may constitute the practice of medicine. This program does not replace the expert advice or medical treatment of my own doctor. I accept that it will be necessary for Hailey Chilton to collect personal, health, and lifestyle information. Medical records and personal information and history will be kept confidential, unless I consent to sharing my medical information. Further, if I would like nutritional advice provided through web-supported platforms (Zoom, Telehealth, etc), I understand and accept that internet associated activities are inherently at risk for a breach of personal information. I understand that if I schedule a web-based session that this implies consent and understanding of these risks. I have agreed to have Hailey Chilton keep records of our visits and to file these in a secure and appropriate place. I have given Hailey Chilton necessary information about myself to prevent any possible complications.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 mt-6">
        <Field
          path="clientStatement.signature"
          label="Signature (Type your full name)"
          type="text"
          required
          placeholder="Digital Signature"
        />
        
        <Field
          path="clientStatement.dateSigned"
          label="Date"
          type="date"
          required
        />
      </div>
    </section>
  );
};

export default ClientStatementSectionV2;